export const createUrl = (arr: Array<string | number>) => `/${arr.join("/")}`;
